<template>
  <div class="home">
    <foreground />
    <scroll-down />
    <div class="container">
      <div class="row">
        <category-info
          class="col-6 col-md-3 col-sm-4"
          :cateInfo="cate"
          v-for="cate in infiniteData.source"
          :key="cate.slug"
        />
      </div> 
    </div>
    <button class="text-uppercase" v-if="isLoadMore" @click="handleLoadmore">
      {{ $t("button.viewMore") }}
    </button>
  </div>
</template>

<script>
import Foreground from "@/components/Foreground.vue";
import CategoryInfo from "@/components/CategoryInfo.vue";
import ScrollDown from "@/components/ScrollDown.vue";
import { mapState } from "vuex";
// import EmbedService from "@/services/EmbedService.js";
import { isEmpty, cloneDeep } from "lodash";
export default {
  name: "Home",
  data: () => ({
    infiniteData: {
      pageSize: 12,
      currentPage: 1,
      isProcessing: false,
      number: 1,
      source: [],
    },
    cateList: [],
  }),
  computed: {
    ...mapState({
      categories: "categories",
    }),
    isLoadMore() {
      return this.infiniteData.source.length < this.cateList.length;
    },
  },
  components: {
    Foreground,
    CategoryInfo,
    ScrollDown,
  },
  async created() {
    await this.doInitData();
  },
  methods: {
    async doInitData() {
      // const embedUrl = await EmbedService.getEmbed(4565);
      // const possibleEmbedUrls = [
      //   embedUrl.data.domain,
      //   'http://localhost:8080/videoPlayer',
      //   'https://mytruelife.org/videoPlayer',
      //   'https://www.churchweb.design/video-player'
      // ]
      // const hostingDomain = (window.location != window.parent.location) ? document.referrer : document.location.href;

      // if (possibleEmbedUrls.includes(hostingDomain)) {
      try {
        const { cat, version } = this.$route.query;
        if (isEmpty(this.categories)) {
          await this.$store.dispatch("fetchCategories", {
            catnames: isEmpty(cat) ? [] : cat.split(","),
            showUnSelected: version ? true : false,
          });
        }

        this.cateList = cloneDeep(this.categories);
        this.handleInifiniteData();
        this.$store.dispatch("setAccountId", this.$route.query.account_id);
      } catch (error) {
        console.error(error);
      }
      // } else {
      //   document.body.innerHTML = "Access Denied";
      // }
    },
    handleLoadmore() {
      this.$set(this.infiniteData, "isProcessing", true);
      this.$set(
        this.infiniteData,
        "currentPage",
        this.infiniteData.currentPage + 1
      );
      setTimeout(() => {
        this.handleInifiniteData();
        this.$set(this.infiniteData, "isProcessing", false);
      }, 100);
    },
    handleInifiniteData() {
      this.$set(
        this.infiniteData,
        "source",
        this.cateList.slice(
          0,
          this.infiniteData.currentPage * this.infiniteData.pageSize
        )
      );
    },
  },
};
</script>
<style lang="scss">
.home {
  padding-bottom: 50px;
  text-align: center;

  .container {
    // max-width: 90%;
    padding-top: 30px;
  }
  > button {
    text-transform: uppercase;
    font-weight: 600;
    margin: auto;
    font-size: 24px;
    border-radius: 24px;
    @media (max-width: 768px) {
      font-size: 14px;
    }
  }
}
</style>
